import { useQuery } from "@tanstack/react-query";
import { getActivitiesMap } from "@/services/activityService";
import { activityKeys } from "./useActivities";
import { apiActivityToFront } from "../useFeed";

export function useMapActivities() {
    return useQuery({
        queryKey: activityKeys.map(),
        queryFn: async () => {
            const activities = await getActivitiesMap();

            return activities.map(apiActivityToFront);
        },
    });
}